<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-response-performance-header">
    <table border="0" class="list-header" cellspacing="0" cellpadding="0">
      <tr class="response-performance-header-row" valign="absmiddle">
        <td class="response-performance-header-flex">
          <div style="display: flex;">
            <div class="search-button material-icons" @click="handleSearch">search</div>
            <el-input ref="searchBarInput" placeholder="Search by responses"
              v-model="keyword" @keypress.enter.native="handleSearch" @keyup.native="handleKeypress" @change="inputChange">      
            </el-input><i class="fas fa-times-circle" v-if="keyword!=''" @click="clearKeywordSearch"></i>
          </div>
          <el-button class="el-dropdown submit-btn save-transcript-btn" :class="savedResponsesEnabled ? 'saved-response-enabled' : ''" @click="toggleSavedResponseFilter">
            <span class="text">Saved</span>
          </el-button>

        </td>

        <td>
          <div class="wy-table-search">
            <table>
            <tr>
              <td class="response-performance-header-flex">
                <wy-table-column :dropdownClassName="'table-col-dropdown-text-show'" class="el-dropdown submit-btn columns-setting-btn" ref="columnSelectionDropdown" :controller="controller" :hidePercentageAll="true" />
                <div style="display: flex;">
                  <div class="search-button material-icons" @click="handleSearch">search</div>
                  <!-- <el-input ref="searchBarInput" placeholder="Search by keyword or response ID"
                    v-model="keyword" @keypress.enter.native="handleSearch">      
                  </el-input><i class="fas fa-times-circle" v-if="keyword!=''" @click="clearKeywordSearch"></i> -->
                </div>
                
              </td>
            </tr>  
            </table>  
          </div>
        </td>
      
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WyTableColumn from '../widgets/wy-table-column';

export default {
  name: 'wy-va-optimization-response-performance-header',
  props: ['controller','searchFields', 'callback'],
  data() {
    return {
      savedResponsesEnabled: false,
      keyword: '',
      searchTimeout: null,
    }
  },

  components: {
    'wy-table-column': WyTableColumn,
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel']),
  },
  methods: {
    isInputActive() {
      return this.dataModel.keyword != "";
    },
    
    async handleSearch() {
      this.controller.loadTables = true
      await this.controller.fetchResponsePerformanceSummary({savedResponses: this.savedResponsesEnabled, keyword: this.keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').toLowerCase()});
      this.controller.loadTables = false;
      this.hightLightKeywords();
      this.updateExportButton();
    },
    hightLightKeywords() {
      this.tableModel.results.forEach(res => {
        if (res.responseName) {
          res.responseName = res.responseName.replace(/<span class='highlight-keywords'>|<\/span>/g, "")
        }
      });
      let search = this.keyword;
      if(search !== ''){
        search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').toLowerCase();
        const regEx = new RegExp(search, 'gi');
      
        this.tableModel.results.forEach(res => {
          if (res.responseName) {
            res.responseName = res.responseName.replace(regEx, "<span class='highlight-keywords'>$&</span>")
          }
        });
      }
    },

    handleIconClick() {
      if(this.isInputActive()) {
        this.dataModel.keyword = '';
        this.$refs.searchBarInput.$el.classList.remove('active');        
      }
      this.handleSearch();
    },
    handleKeypress() {
      if(this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(()=>{ 
        this.handleSearch()
        if(this.isInputActive()) {
          this.$refs.searchBarInput.$el.classList.add('active');
        }
        else {
          this.$refs.searchBarInput.$el.classList.remove('active');
        }
      }, 400);
    },

    inputChange() {
      if(this.keyword == '') {
        this.dataModel.keyword = this.keyword; 
      }
    },
    clearKeywordSearch() {
      this.keyword ='';
      this.dataModel.keyword = this.keyword; 
      this.handleSearch();
    },

    updateExportButton() {
      const savedTranscriptExists = this.tableModel && this.tableModel.results && this.tableModel.results.length > 0;

      if (savedTranscriptExists) {
        this.controller.disableExport = false
      } else {
        this.controller.disableExport = true
      }
    },

    async toggleSavedResponseFilter() {
      this.savedResponsesEnabled = !this.savedResponsesEnabled;

      this.controller.loadTables = true
      await this.controller.fetchResponsePerformanceSummary({savedResponses: this.savedResponsesEnabled, keyword: this.keyword});
      this.controller.loadTables = false

      this.updateExportButton()
    },
  },

  created() {
    this.keyword = this.dataModel.keyword;
    
    if(this.dataModel.fieldName === null && this.searchFields) {
      // get the default selected field
      let selectedField = this.searchFields[0];
      this.dataModel.fieldName = selectedField.name;      
    }
  },

  mounted() {
    this.keyword = '';
  },
  beforeDestroy() {
    this.dataModel.keyword = '';
  }
}
</script>

<style lang="scss">
.wy-va-optimization-response-performance-header {
  // border: 1px solid #CAD2DA;
  display: flex;
  justify-content: space-between;
  height: 60px;
  width: 100%;
  background-color: #FFF;
  border-top: unset;
  align-items: center;
  .wy-table-search .search-button {
    display: none;
  }
  > table {
    width: 100%;
    .col3 {
      text-align: right;
    }
  }
  .el-input__suffix{
    background-image: url('../../assets/icons/icon_res_close.svg');
    background-repeat: no-repeat;
    background-position-y: 5px;
  }
  .el-icon-circle-close:before {
    content: "";
  }
  .table-header {
    border: 1px solid #CAD2DA;
    height: 60px;
    background-color: #FFF;
    color: var(--site-font-secondary-color);
    font-weight: 500;
    display: flex;
    font-size: 20px;
    width: 100%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-top: 20px;
    align-items: center;
  }
  .saved-response-enabled {
    background-color: #e8f1ff !important;
    border: 1px solid #106FBC !important;
  }

  .list-header-group {
    display: inline-flex;
  } 
  
  .response-performance-header-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .columns-setting-btn {
    margin-top: 6px;
    margin-right: 5px;
    float: left;
    height: 36px;
    margin-right: 0px;
    background-image: unset;
    background-color: transparent;
    width: fit-content;
    align-items: center;
    color: #202223;
  }
  .save-transcript-btn {
    margin-top: 6px;
    float: left;
    position: absolute;
    left: 358px;
    background-image: url('../../assets/icons/icon_golden_star.svg');
    background-size: 20%;
    background-repeat: no-repeat;
    padding: 13px 10px 12px 15px;
    height: 34px;
    background-color: white;
    display: flex;
    margin-right: 15px;
    border:1px solid #CAD2DA;
    font-weight: 400;
    border-radius: 4px;
    width: fit-content;
    font-size: 14.22px;
    align-items: center;
    background-position-x: 8px;
    background-position-y: 7px;
    color: #202223;
      span.text {
        padding-left: 15px;
      }
    }

    .response-performance-header-flex{
      display: flex;
      // margin-left: 20px;
      align-items: flex-end;

      .el-button:focus {
        background-color: unset;
      }
      .el-button--default.save-transcript-btn:hover {
        background-color: #f4f6f8;
      }
      button.el-button.el-dropdown.submit-btn.columns-setting-btn.el-button--default:hover {
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
    .save-transcript-btn.saved-response-filter:hover {
      // background-color: #214586;
      // color: #FFF;
      background-color: #F4F6F8;
      color: var(--site-font-tertiary-color);
    }
    .save-transcript-btn.saved-response-filter:focus {
      // background-color: #214586;
      color: var(--site-font-tertiary-color);
    }

    .columns-setting-btn{
      &:hover{
        // background-color: #F4F6F8;
        // border-color: #c6e2ff;
        background-color: #f4f6f8;
      }
    }

  .title {
    display: inline-block;
    color: var(--site-font-secondary-color);
    font-size: 25px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
  }

  .column-filter {
    height: 34px;
    display: inline-block;
  }

  .wy-table-column {
    text-align: right;
  }
  .wy-table-search {
    table {
      border-spacing: 0px;
    }
    .el-input__icon.el-icon-click{
      background-size: 15px 20px;
      background-position-y: 3px;
      background-position-x: 5px;
    }
    div.el-input, .wy-table-search .el-input-group {
      width: 200px;
    }
    div.el-input:focus-within{
      border: 1px solid #106FBC;
    }
  }
  div.el-input, .el-input-group {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #D7D7D8;
    border-radius: 4px;
    opacity: 1;
    width: 258px !important;
    margin-left: 0px;
    padding-left: 12px;
    height: 33px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-right: 50px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    &:hover{
      background: #F3F6F8 0% 0% no-repeat padding-box;
    }
    &:focus-within{
      border: 1px solid #106FBC;
      background: #FFFFFF 0% 0% no-repeat padding-box;
    }
  }

  .el-button:active{
    border-color: none !important;
  }
  .search-button {
    background-color: var(--site-font-tertiary-color);
    border-radius: 8px;
    width: 38px;
    height: 23px;
    text-align: center;
    margin-top: 4px;
    position: relative;
    left: 301px;
    padding: 3px 0px 0px 0px;
    font-size: 22px;
    position: absolute;
    z-index: 1;
    background: transparent;
    color: #5C5F62;
    cursor: pointer;
  }

  input {
    border: none;
    padding-left: 0px !important;
    height: 30px !important;
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
    background-color: transparent !important;
    &:hover {
      background: #F3F6F8;
    }

    &:focus-within {
      background: transparent;
    }
  }
  input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #4B5158;
    opacity: 1; /* Firefox */
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #4B5158;
  }

  input::-ms-input-placeholder { /* Microsoft Edge */
    color: #4B5158;
  }
  .el-input-group__append {
    border: none;
    background-color: #fff;
    border-left: 1px solid #D7D7D8 !important;
  }
  .el-input__icon {
    line-height: 32px;
  }
  .el-input__icon.el-icon-click {
    background-image: url('../../assets/icons/icon_search.svg');
    background-repeat: no-repeat;
    background-size: 20px 28px;
    background-position-y: 1px;
    background-position-x: 5px;
  }
  .el-input__icon.el-icon-click:hover {
    cursor: pointer;
  }
  .el-input__icon.el-icon-click::before {
    content: ''
  }
  .el-input__icon.el-icon-click {
    content: ''
  }

  .el-select {
    .el-input__inner {
      color: #B3B3B3;
    }
  }
  .el-select__caret {
    background-image: url('../../assets/icons/icon_dropdown_down.svg');
    background-repeat: no-repeat;
    background-size: 12px 9px;
    background-position-y: 16px;
    background-position-x: 3px;
    transform: none;
  }
  .el-select__caret::before {
    content: ''
  }
  .el-select__caret::after {
    content: ''
  }      
  .fa-times-circle {
    position: relative;
    left: -52px;
    bottom: 0px;
    top: 8px;
    float: right;
    color: #5C5F62 !important;
    font-size: 20px;
    cursor: pointer;
  } 
}
.el-input-group.active {
  .el-input__inner {
    color: var(--site-font-primary-color);
  }
  .el-select__caret {
    background-image: url('../../assets/icons/icon_dropdown_blue_down.svg');
  }
  .el-input__icon.el-icon-click {
    background-image: url('../../assets/icons/icon_delete.svg') !important;
  }
}

.wy-seardh-bar-select {
  .el-select-dropdown__item.selected {
    color: var(--site-font-primary-color) !important;
  }
}
</style>
